<template>
  <kst-table paginated view-mode
    :data="items"
    :loading="isListLoading"
    :selected.sync="userData.selected"
  >

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-image"
      field="ImageSrc"
      :label="ItemCatalog.ImageSrc.Label"
    >
      <kst-image read-only thumbnail :src="row[column.field]"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      field="Name"
      :label="ItemCatalog.Name.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="ItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      field="SKU"
      :label="ItemCatalog.SKU.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="ItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      field="Packaging"
      :label="ItemCatalog.Packaging.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="ItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      field="BuyPrice"
      :label="ItemCatalog.BuyPrice.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="ItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      field="PurchasingItemQty"
      :label="ItemCatalog.PurchasingItemQty.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="ItemCatalog"/>
    </b-table-column>

  </kst-table>
</template>

<script>
import ItemCatalog from "../ReceiveItemCatalog.js";
import Model from "../ReceiveModel.js";

export default {
  props: {
    isListLoading: Boolean,
    items: Array,
    userData: Object
  },
  data: () => ({
    ItemCatalog: ItemCatalog,
    Model: Model
  }),
  methods: {
    handleAdd_NewItem() {
      this.$emit(this.$kst.Enum.Event.NewItem);
    }
  }
}
</script>